

export const PARCEL_SERVICE_URL = 'https://www.horrycounty.org/parcelapp/rest/services/HorryCountyGISApp/MapServer/24'